.rbe6id0 {
  min-width: 0;
  overflow: hidden;
  flex: 0 1 auto;
  max-width: 100%;
}